import { motion } from 'motion/react';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  // Which of the three steps is showing. `null` is the mic probe, which has no step of its own.
  step: number | null;
  label: string;
  // Changes with the step so the incoming panel animates in rather than swapping in place.
  animationKey: string;
}

const STEP_COUNT = 3;

export default function WizardFrame({ step, label, animationKey, children }: Props) {
  return (
    <div className="flex min-h-0 flex-1 flex-col p-5" data-test="wizard">
      <div className="flex shrink-0 gap-2" aria-hidden>
        {Array.from({ length: STEP_COUNT }, (_, index) => (
          <span
            key={index}
            className={`h-[0.3125rem] flex-1 rounded-full transition-colors duration-300 ${
              step !== null && index <= step ? 'bg-active' : 'bg-white/22'
            }`}
          />
        ))}
      </div>
      <span className="mt-2.5 shrink-0 text-[0.8125rem] tracking-[0.08em] text-white/70 uppercase">{label}</span>
      <motion.div
        key={animationKey}
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: [0.22, 0.61, 0.36, 1] }}
        className="flex min-h-0 flex-1 flex-col">
        {children}
      </motion.div>
    </div>
  );
}
